function navState() {
  const toggleElement = document.querySelector('[data-nav-toggle]');

  if (!toggleElement) return;

  toggleElement.addEventListener('click', toggleNav);
}
navState();

function toggleNav() {
  console.log('testing');
  const navId = this.getAttribute('data-nav-toggle');
  const navElement = document.getElementById(navId);
  if (!navElement) return;

  const navOpen = navElement.classList.contains('is-open');

  changeNavState(navElement, !navOpen);
}

function changeNavState(navElement, state) {
  const navOpen = state === true || state === 'open';
  const header = document.querySelector('header.header');

  if (navOpen) {
    navElement.classList.add('is-open');
    navElement.style.setProperty(
      '--nav-mobile-padding',
      header.offsetHeight + 20 + 'px'
    );
    document.addEventListener('keyup', navCloseListener);
  } else {
    navElement.classList.remove('is-open');
  }

  if (navElement.getAttribute('data-nav-toggler')) {
    const navToggle = document.getElementById(
      navElement.getAttribute('data-nav-toggler')
    );

    if (navOpen) {
      navToggle.classList.add('is-active');
    } else {
      navToggle.classList.remove('is-active');
    }
  }
}

function navCloseListener(event) {
  console.log('TEst');
  console.log(event.key);
}

export { navState };
